import { render, staticRenderFns } from "./SaldoCoinIcon.vue?vue&type=template&id=065ba96d"
import script from "./SaldoCoinIcon.vue?vue&type=script&lang=js"
export * from "./SaldoCoinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports